// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsScimScimResetTokenResult = objectOf({
  auth_token: string,
});
